import React, { useState, useEffect } from 'react';
import { Check, X, Eye, Clock, Filter, Search, Download, FileText, User, Calendar, BookOpen } from 'lucide-react';
import * as XLSX from 'xlsx';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

const DireccionSolicitudesCambio = () => {
    const [solicitudes, setSolicitudes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filtroEstado, setFiltroEstado] = useState('todos');
    const [filtroGestion, setFiltroGestion] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [gestiones, setGestiones] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedSolicitud, setSelectedSolicitud] = useState(null);
    const [observaciones, setObservaciones] = useState('');
    const [actionType, setActionType] = useState('');
    const [updating, setUpdating] = useState(false);

    useEffect(() => {
        loadGestiones();
    }, []);

    useEffect(() => {
        loadSolicitudes();
    }, [filtroEstado, filtroGestion, searchQuery]);

    const loadGestiones = async () => {
        try {
            const response = await fetch(`${API_URL}/direccion/movimientos/gestiones`);
            const data = await response.json();
            const listaGestiones = data.gestiones || [];
            setGestiones(listaGestiones);
            if (listaGestiones.length > 0) setFiltroGestion(listaGestiones[0].toString());
        } catch (error) {
            console.error('Error loading gestiones:', error);
        }
    };

    const loadSolicitudes = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            if (filtroEstado && filtroEstado !== 'todos') params.append('estado', filtroEstado);
            if (filtroGestion) params.append('gestion', filtroGestion);
            if (searchQuery) params.append('search', searchQuery);

            const response = await fetch(`${API_URL}/direccion/movimientos-academicos?${params.toString()}`);
            const data = await response.json();
            setSolicitudes(data.solicitudes || []);
        } catch (error) {
            console.error('Error loading solicitudes:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleAction = async (sol, newState, obs = '') => {
        if (newState === 'rechazado' && !obs.trim()) {
            alert('Debe ingresar un motivo para el rechazo');
            return;
        }

        setUpdating(true);
        try {
            const response = await fetch(`${API_URL}/direccion/movimientos/${sol.tipo}/${sol.id_solicitud}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ estado: newState, observaciones: obs })
            });

            if (response.ok) {
                setShowModal(false);
                loadSolicitudes();
            } else {
                const errorData = await response.json();
                alert('Error al actualizar estado: ' + (errorData.error || errorData.message || 'Error desconocido'));
            }
        } catch (error) {
            console.error('Error updating status:', error);
            alert('Error de conexión');
        } finally {
            setUpdating(false);
        }
    };

    const downloadExcel = () => {
        const dataToExport = solicitudes.map(sol => ({
            'Código': sol.codigo_estudiante || '-',
            'Nombres': sol.nombres,
            'Apellidos': `${sol.apellido_paterno} ${sol.apellido_materno}`,
            'CI': sol.cedula_identidad,
            'Fecha Solicitud': new Date(sol.fecha_solicitud).toLocaleDateString(),
            'Gestión': sol.gestion_anio,
            'Tipo': sol.tipo === 'cambio_carrera' ? 'Cambio Carrera' : 'Cambio Asignatura',
            'Carrera Inicial': sol.carrera_inicial || '-',
            'Carrera Modificada': sol.carrera_modificada || '-',
            'Mención Inicial': sol.mencion_inicial || '-',
            'Mención Modificada': sol.mencion_modificada || '-',
            'Asignatura Inicial': sol.asignatura_inicial ? `${sol.asignatura_inicial} (${sol.paralelo_inicial})` : '-',
            'Docente Inicial': sol.docente_inicial || '-',
            'Asignatura Modificada': sol.asignatura_modificada ? `${sol.asignatura_modificada} (${sol.paralelo_modificado})` : '-',
            'Docente Modificado': sol.docente_modificado || '-',
            'Estado': sol.estado.toUpperCase(),
            'Motivo Rechazo/Resolución': sol.observaciones || '-'
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Movimientos');
        XLSX.writeFile(wb, `Solicitudes_Cambio_${new Date().toISOString().split('T')[0]}.xlsx`);
    };

    const getEstadoColor = (estado) => {
        switch (estado) {
            case 'enviado':
            case 'preaprobado':
            case 'pendiente': return 'bg-purple-100 text-purple-700 border-purple-200';
            case 'aprobado': return 'bg-emerald-100 text-emerald-700 border-emerald-200';
            case 'rechazado': return 'bg-rose-100 text-rose-700 border-rose-200';
            default: return 'bg-slate-100 text-slate-700 border-slate-200';
        }
    };

    return (
        <div className="p-6 bg-slate-50 min-h-screen">
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h1 className="text-xl font-bold text-gray-800">Dirección Académica &gt; Autorizaciones &gt; Movimientos Académicos</h1>
                </div>
                {/* <button
                    onClick={downloadExcel}
                    className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg transition-all shadow-sm hover:shadow-md"
                >
                    <Download size={18} />
                    <span>Exportar Excel</span>
                </button> */}
            </div>

            {/* Filtros */}

            <div className="mb-6 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
                <div className="flex flex-wrap items-center gap-4">

                    {/* BUSCAR Y EXCEL */}
                    <div className="flex-grow flex items-center gap-2">
                        <div className="relative flex-grow">
                            <label className="block text-xs font-semibold text-gray-500 mb-1 ml-1">BUSCAR</label>
                            <div className="relative">
                                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                                <input
                                    type="text"
                                    placeholder="Buscar..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="w-full h-[38px] pl-10 pr-4 border border-gray-300 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 hover:border-blue-500"
                                />
                            </div>
                        </div>

                    </div>

                    {/* GESTIÓN */}
                    <div className="relative">
                        <label className="block text-xs font-semibold text-gray-500 mb-1 ml-1">GESTIÓN</label>
                        <div className="relative">
                            <select
                                value={filtroGestion}
                                onChange={(e) => setFiltroGestion(e.target.value)}
                                className="h-[38px] px-4 border border-gray-300 rounded-full bg-white text-sm appearance-none pr-8 hover:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100 min-w-[100px]"
                            >
                                <option value="">Todas las gestiones</option>
                                {gestiones.map(g => (
                                    <option key={g} value={g}>{g}</option>
                                ))}
                            </select>
                            <span className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 text-xs">▼</span>
                        </div>
                    </div>

                    {/* ESTADO */}
                    <div className="relative">
                        <label className="block text-xs font-semibold text-gray-500 mb-1 ml-1">ESTADO</label>
                        <div className="flex items-center bg-gray-50 p-0.5 border border-gray-200 rounded-full h-[38px]">
                            {['todos', 'pendiente', 'aprobado', 'rechazado'].map((est) => (
                                <button
                                    key={est || 'todos'}
                                    onClick={() => setFiltroEstado(est)}
                                    className={`h-full px-4 rounded-full text-sm font-medium transition flex items-center justify-center ${filtroEstado === est
                                        ? 'bg-blue-900 text-white shadow-sm'
                                        : 'text-gray-700 hover:bg-gray-200'
                                        }`}
                                >
                                    {est.charAt(0).toUpperCase() + est.slice(1)}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="flex flex-col">
                        <label className="block text-xs font-semibold text-transparent mb-1 ml-1 select-none">ACCION</label>

                        <button
                            onClick={downloadExcel}
                            className="h-[38px] w-[38px] flex items-center justify-center bg-green-600 text-white rounded-full hover:bg-green-700 transition shadow-sm"
                            title="Descargar Excel"
                        >
                            <Download size={18} />
                        </button>
                    </div>
                </div>
            </div>
            {/* <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-5 mb-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                    <div>
                        <label className="block text-xs font-semibold text-slate-500 uppercase mb-2 ml-1">Buscador</label>
                        <div className="relative">
                            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
                            <input
                                type="text"
                                placeholder="Nombre, CI o Código..."
                                className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all bg-slate-50/50"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-xs font-semibold text-slate-500 uppercase mb-2 ml-1">Gestión</label>
                        <select
                            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all bg-slate-50/50"
                            value={filtroGestion}
                            onChange={(e) => setFiltroGestion(e.target.value)}
                        >
                            <option value="">Todas las gestiones</option>
                            {gestiones.map(g => (
                                <option key={g} value={g}>{g}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block text-xs font-semibold text-slate-500 uppercase mb-2 ml-1">Estado</label>
                        <div className="flex p-1 bg-slate-100 rounded-lg w-max">
                            {['todos', 'pendiente', 'aprobado', 'rechazado'].map((est) => (
                                <button
                                    key={est}
                                    onClick={() => setFiltroEstado(est)}
                                    className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${filtroEstado === est
                                        ? 'bg-white text-blue-600 shadow-sm'
                                        : 'text-slate-500 hover:text-slate-700'
                                        }`}
                                >
                                    {est.charAt(0).toUpperCase() + est.slice(1)}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div> */}

            {/* Tabla */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-3 py-3 text-center font-semibold border">Estudiante</th>
                                <th className="px-3 py-3 text-center font-semibold border">CI / Código</th>
                                <th className="px-3 py-3 text-center font-semibold border">Fecha</th>
                                <th className="px-3 py-3 text-center font-semibold border">Carrera Inicial / Modif.</th>
                                <th className="px-3 py-3 text-center font-semibold border">Mención Inicial / Modif.</th>
                                <th className="px-3 py-3 text-center font-semibold border">Paralelo Inicial / Modif.</th>
                                <th className="px-3 py-3 text-center font-semibold border">Estado / Acción</th>
                                {filtroEstado !== 'pendiente' && (
                                    <th className="px-3 py-3 text-center font-semibold border">Observaciones</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={filtroEstado !== 'pendiente' ? 8 : 7} className="py-20 text-center">
                                        <div className="flex flex-col items-center gap-3">
                                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                                            <span className="text-slate-500 font-medium">Cargando solicitudes...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : solicitudes.length === 0 ? (
                                <tr>
                                    <td colSpan={filtroEstado !== 'pendiente' ? 8 : 7} className="py-20 text-center text-slate-400 font-medium">
                                        No se encontraron resultados para los filtros seleccionados
                                    </td>
                                </tr>
                            ) : (
                                solicitudes.map((sol) => (
                                    <tr key={`${sol.tipo}-${sol.id_solicitud}`} className="hover:bg-gray-50">
                                        <td className="px-3 py-2 border">
                                            <div className="font-bold text-slate-800">{sol.nombres}</div>
                                            <div className="text-slate-500">{sol.apellido_paterno} {sol.apellido_materno}</div>
                                        </td>
                                        <td className="px-3 py-2 border">
                                            <div className="flex flex-col">
                                                <span className="text-slate-700 font-medium">{sol.cedula_identidad}</span>
                                                <span className="text-xs font-mono text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded w-max mt-1">{sol.codigo_estudiante || 'S/C'}</span>
                                            </div>
                                        </td>
                                        <td className="px-3 py-2 border">
                                            {new Date(sol.fecha_solicitud).toLocaleDateString()}
                                        </td>
                                        <td className="px-3 py-2 border">
                                            <div className="text-xs text-slate-400 line-through mb-1">{sol.carrera_inicial || 'N/A'}</div>
                                            <div className="font-medium text-emerald-600">{sol.carrera_modificada || 'N/A'}</div>
                                        </td>
                                        <td className="px-3 py-2 border">
                                            <div className="text-xs text-slate-400 line-through mb-1">{sol.mencion_inicial || 'N/A'}</div>
                                            <div className="font-medium text-emerald-600">{sol.mencion_modificada || 'N/A'}</div>
                                        </td>
                                        <td className="px-3 py-2 border ">
                                            {sol.tipo === 'edicion_estudiante' ? (
                                                <span className="text-xs font-bold text-amber-600 bg-amber-50 px-2 py-1 rounded">EDICIÓN INFO</span>
                                            ) : (
                                                <>
                                                    <div className="text-xs text-slate-400 line-through mb-1 uppercase tracking-tighter truncate max-w-[150px]">
                                                        {sol.asignatura_inicial || 'N/A'}
                                                        {sol.paralelo_inicial && ` (${sol.paralelo_inicial})`}
                                                    </div>
                                                    <div className="font-medium text-emerald-700 leading-tight">
                                                        {sol.asignatura_modificada || 'N/A'}
                                                        {sol.paralelo_modificado && (
                                                            <div className="text-[10px] text-slate-400 flex items-center gap-1 mt-0.5">
                                                                <BookOpen size={10} /> {sol.paralelo_modificado} • {sol.docente_modificado}
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                        </td>
                                        <td className="px-3 py-2 border">
                                            <div className="flex items-center justify-center">
                                                <div className="relative group/select">
                                                    <select
                                                        className={`text-xs border rounded-lg px-3 py-1.5 outline-none font-bold cursor-pointer transition-all appearance-none pr-8 shadow-sm hover:shadow-md ${['enviado', 'pendiente', 'preaprobado'].includes(sol.estado?.toLowerCase()) ? 'bg-purple-50 border-purple-200 text-purple-700 hover:bg-purple-100' :
                                                            sol.estado === 'aprobado' ? 'bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100' :
                                                                sol.estado === 'rechazado' ? 'bg-rose-50 border-rose-200 text-rose-700 hover:bg-rose-100' :
                                                                    'bg-slate-50 border-slate-200 text-slate-600'
                                                            }`}
                                                        value={['enviado', 'preaprobado'].includes(sol.estado?.toLowerCase()) ? 'pendiente' : sol.estado}
                                                        onChange={(e) => {
                                                            if (e.target.value !== sol.estado) {
                                                                setSelectedSolicitud(sol);
                                                                setActionType(e.target.value);
                                                                setObservaciones(sol.observaciones || '');
                                                                setShowModal(true);
                                                            }
                                                        }}
                                                    >
                                                        <option value="pendiente">PENDIENTE</option>
                                                        <option value="aprobado">APROBADO</option>
                                                        <option value="rechazado">RECHAZADO</option>
                                                    </select>
                                                    <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none opacity-40">
                                                        <Clock size={12} />
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        {filtroEstado !== 'pendiente' && (
                                            <td className="px-3 py-2 border">
                                                <div className={`text-xs p-2 rounded-lg ${sol.estado === 'rechazado' ? 'bg-rose-50 text-rose-700 border border-rose-100' : 'bg-slate-50 text-slate-500'}`}>
                                                    {sol.observaciones || '-'}
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal de confirmación Premium */}
            {showModal && selectedSolicitud && (
                <div className="fixed inset-0 flex items-center justify-center z-50 p-4 bg-black/50">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden border border-slate-200">
                        {/* Header dinámico */}
                        {/* <div className={`px-6 py-4 flex items-center justify-between ${actionType === 'aprobado' ? 'bg-emerald-600' :
                            actionType === 'rechazado' ? 'bg-rose-600' :
                                actionType === 'pendiente' ? 'bg-purple-600' :
                                    'bg-blue-600'
                            }`}>
                            <div className="flex items-center gap-3 text-white">
                                {actionType === 'aprobado' ? <Check size={24} /> :
                                    actionType === 'rechazado' ? <X size={24} /> :
                                        actionType === 'pendiente' ? <Clock size={24} /> :
                                            <Clock size={24} />}
                                <h2 className="text-xl font-bold uppercase tracking-wide">
                                    {actionType === 'aprobado' ? 'Aprobar Solicitud' :
                                        actionType === 'rechazado' ? 'Rechazar Solicitud' :
                                            'Marcar Pendiente'}
                                </h2>
                            </div>
                            <button
                                onClick={() => setShowModal(false)}
                                className="text-white/80 hover:text-white transition-colors p-1"
                            >
                                <X size={24} />
                            </button>
                        </div> */}
                        <div className="px-6 py-4 flex items-center justify-between sticky top-0 bg-white border-b flex justify-between items-center mb-4">
                            <h2 className="text-xl font-bold text-blue-900">
                                {actionType === 'aprobado' ? 'Aprobar Solicitud' :
                                    actionType === 'rechazado' ? 'Rechazar Solicitud' :
                                        'Marcar Pendiente'}
                            </h2>
                            <button onClick={() => setShowModal(false)} className="text-gray-400 hover:text-gray-600">
                                <X size={20} />
                            </button>
                        </div>

                        <div className="p-6">
                            <div className="space-y-4">
                                {/* Info del Estudiante */}
                                <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
                                    <div className="flex items-center gap-3 mb-3 pb-3 border-b border-slate-200/50">
                                        <div className="bg-blue-600 text-white h-10 w-10 rounded-full flex items-center justify-center font-bold shadow-inner shrink-0">
                                            {selectedSolicitud.nombres ? selectedSolicitud.nombres.charAt(0) : 'U'}
                                        </div>
                                        <div>
                                            <div className="font-bold text-slate-800 leading-none mb-1">
                                                {selectedSolicitud.nombres} {selectedSolicitud.apellido_paterno} {selectedSolicitud.apellido_materno}
                                            </div>
                                            <div className="text-xs text-slate-500 font-mono tracking-tighter">
                                                {selectedSolicitud.codigo_estudiante} • {selectedSolicitud.cedula_identidad}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-2 text-sm text-slate-600">
                                        <div className="flex justify-between items-center">
                                            <span className="font-medium">Tipo de Solicitud:</span>
                                            <span className="font-bold text-slate-800 px-2 py-0.5 bg-slate-200 rounded text-[10px] uppercase">
                                                {selectedSolicitud.tipo === 'cambio_carrera' ?
                                                    (selectedSolicitud.id_carrera_origen === selectedSolicitud.id_carrera_destino ? 'Cambio Mención' : 'Cambio Carrera') :
                                                    'Cambio de Paralelo'}
                                            </span>
                                        </div>

                                        {/* Comparativa de cambios */}
                                        <div className="mt-4 pt-4 border-t border-slate-100">
                                            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 text-center">Detalle del Movimiento</p>
                                            <div className="flex items-center gap-4">
                                                <div className="flex-1 p-3 bg-slate-100 rounded border border-slate-200 text-center">
                                                    <p className="text-[9px] text-slate-400 font-bold uppercase">Actual</p>
                                                    <p className="text-xs font-medium mt-1">
                                                        {selectedSolicitud.tipo === 'cambio_carrera' ?
                                                            (selectedSolicitud.id_carrera_origen === selectedSolicitud.id_carrera_destino ? selectedSolicitud.mencion_inicial || 'Sin Mención' : selectedSolicitud.carrera_inicial) :
                                                            `${selectedSolicitud.asignatura_inicial} (${selectedSolicitud.paralelo_inicial})`}
                                                    </p>
                                                    {selectedSolicitud.tipo === 'cambio_asignatura' && (
                                                        <p className="text-[10px] text-slate-500 mt-1 font-bold">
                                                            Docente: {selectedSolicitud.docente_inicial}
                                                        </p>
                                                    )}
                                                    {selectedSolicitud.tipo === 'cambio_carrera' && selectedSolicitud.id_carrera_origen !== selectedSolicitud.id_carrera_destino && selectedSolicitud.mencion_inicial && (
                                                        <p className="text-[10px] text-slate-500 mt-1 font-bold">
                                                            M: {selectedSolicitud.mencion_inicial}
                                                        </p>
                                                    )}
                                                </div>
                                                <Filter size={16} className="text-slate-300 rotate-90 shrink-0" />
                                                <div className="flex-1 p-3 bg-emerald-50 rounded border border-emerald-200 text-center">
                                                    <p className="text-[9px] text-emerald-500 font-bold uppercase">Nuevo</p>
                                                    <p className="text-xs font-bold text-emerald-700 mt-1">
                                                        {selectedSolicitud.tipo === 'cambio_carrera' ?
                                                            (selectedSolicitud.id_carrera_origen === selectedSolicitud.id_carrera_destino ? selectedSolicitud.mencion_modificada || 'Sin Mención' : selectedSolicitud.carrera_modificada) :
                                                            `${selectedSolicitud.asignatura_modificada} (${selectedSolicitud.paralelo_modificado})`}
                                                    </p>
                                                    {selectedSolicitud.tipo === 'cambio_asignatura' && (
                                                        <p className="text-[10px] text-emerald-600 mt-1 font-bold">
                                                            Docente: {selectedSolicitud.docente_modificado}
                                                        </p>
                                                    )}
                                                    {selectedSolicitud.tipo === 'cambio_carrera' && selectedSolicitud.id_carrera_origen !== selectedSolicitud.id_carrera_destino && selectedSolicitud.mencion_modificada && (
                                                        <p className="text-[10px] text-emerald-600 mt-1 font-bold">
                                                            M: {selectedSolicitud.mencion_modificada}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Campo de Observaciones */}
                                <div>
                                    <label className="block text-xs font-bold text-slate-500 uppercase mb-2 ml-1 flex items-center justify-between">
                                        Observaciones / Motivo
                                        {actionType === 'rechazado' && <span className="text-rose-500 text-[10px] font-bold">REQUERIDO *</span>}
                                    </label>
                                    <textarea
                                        value={observaciones}
                                        onChange={(e) => setObservaciones(e.target.value)}
                                        rows="3"
                                        className={`w-full border rounded-xl px-4 py-3 outline-none focus:ring-4 transition-all resize-none text-slate-700 text-sm ${actionType === 'rechazado' ? 'focus:ring-rose-100 focus:border-rose-400' : 'focus:ring-blue-100 focus:border-blue-400'
                                            } border-slate-200 shadow-inner bg-slate-50/30`}
                                        placeholder={actionType === 'rechazado' ? 'Indique detalladamente por qué se rechaza la solicitud...' : 'Agregar nota adicional sobre la resolución...'}
                                    />
                                </div>
                            </div>
                            <div className="flex justify-end gap-3 mt-6">
                                <button
                                    onClick={() => setShowModal(false)}
                                    className="px-4 py-2 border rounded-lg hover:bg-gray-50"
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={() => handleAction(selectedSolicitud, actionType, observaciones)}
                                    disabled={updating}
                                    className={`px-4 py-2 rounded-lg text-white bg-blue-900 hover:bg-blue-800 ${actionType === 'aprobado' ? 'ring-2 ring-blue-300' : ''
                                        }`}
                                >
                                    {updating ? 'Guardando...' : `Confirmar ${actionType}`}
                                </button>
                            </div>

                            {/* <div className="mt-8 flex gap-3">
                                <button
                                    onClick={() => setShowModal(false)}
                                    className="flex-1 px-4 py-3 rounded-xl font-bold text-slate-500 hover:bg-slate-100 transition-colors uppercase text-xs tracking-wider"
                                    disabled={updating}
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={() => handleAction(selectedSolicitud, actionType, observaciones)}
                                    disabled={updating}
                                    className={`flex-1 px-4 py-3 rounded-xl font-bold text-white shadow-lg transition-all active:scale-95 disabled:opacity-50 uppercase text-xs tracking-wider ${actionType === 'aprobado'
                                        ? 'bg-emerald-600 hover:bg-emerald-700 shadow-emerald-200'
                                        : actionType === 'rechazado'
                                            ? 'bg-rose-600 hover:bg-rose-700 shadow-rose-200'
                                            : 'bg-blue-600 hover:bg-blue-700 shadow-blue-200'
                                        }`}
                                >
                                    {updating ? (
                                        <div className="h-5 w-5 border-2 border-white/30 border-t-white rounded-full animate-spin mx-auto" />
                                    ) : (
                                        `Confirmar ${actionType}`
                                    )}
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DireccionSolicitudesCambio;
